import { useNotificationSettings } from './useNotificationSettings';
import './NotificationSettings.css';

function Toggle({ checked, onChange, disabled }) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            className={`ns-toggle ${checked ? 'ns-toggle--on' : ''} ${disabled ? 'ns-toggle--disabled' : ''}`}
            onClick={disabled ? undefined : onChange}
            disabled={disabled}
        >
            <span className="ns-toggle-thumb" />
        </button>
    );
}

function NotificationSettings() {
    const {
        settings,
        updateSettings,
        permissionState,
        supported,
        toggleEnabled,
    } = useNotificationSettings();

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const subDisabled = !settings.enabled;

    return (
        <div className="ns-root">
            {/* Header */}
            <div className="ns-header">
                <svg className="ns-bell-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
                <h3 className="ns-title">Notifications</h3>
            </div>

            {/* Not supported banner */}
            {!supported && (
                <div className="ns-banner ns-banner--warn">
                    Your browser doesn't support notifications. Try Chrome or Safari on a newer device.
                </div>
            )}

            {/* Permission denied banner */}
            {supported && permissionState === 'denied' && (
                <div className="ns-banner ns-banner--warn">
                    Notifications are blocked. Open your browser settings for this site and allow notifications.
                </div>
            )}

            {/* Master toggle */}
            <div className="ns-card">
                <div className="ns-row">
                    <div className="ns-row-text">
                        <span className="ns-row-label">Enable Notifications</span>
                        <span className="ns-row-desc">Get reminders to take your supplements</span>
                    </div>
                    <Toggle
                        checked={settings.enabled}
                        onChange={toggleEnabled}
                        disabled={!supported}
                    />
                </div>
            </div>

            {/* Reminder time */}
            <div className={`ns-card ${subDisabled ? 'ns-card--disabled' : ''}`}>
                <div className="ns-section-label">Reminder Time</div>
                <input
                    type="time"
                    className="ns-time-input"
                    value={settings.reminderTime}
                    onChange={(e) => updateSettings({ reminderTime: e.target.value })}
                    disabled={subDisabled}
                />
            </div>

            {/* Notification types */}
            <div className={`ns-card ${subDisabled ? 'ns-card--disabled' : ''}`}>
                <div className="ns-section-label">Notification Types</div>

                <div className="ns-row">
                    <div className="ns-row-text">
                        <span className="ns-row-label">Daily protocol reminder</span>
                        <span className="ns-row-desc">Get reminded to take your supplements</span>
                    </div>
                    <Toggle
                        checked={settings.types.dailyReminder}
                        onChange={() => updateSettings({ types: { dailyReminder: !settings.types.dailyReminder } })}
                        disabled={subDisabled}
                    />
                </div>

                <div className="ns-divider" />

                <div className="ns-row">
                    <div className="ns-row-text">
                        <span className="ns-row-label">Missed dose nudge</span>
                        <span className="ns-row-desc">Follow-up if you haven't completed by evening</span>
                    </div>
                    <Toggle
                        checked={settings.types.missedDose}
                        onChange={() => updateSettings({ types: { missedDose: !settings.types.missedDose } })}
                        disabled={subDisabled}
                    />
                </div>
            </div>

            {/* PWA install hint */}
            {!isStandalone && supported && (
                <div className="ns-hint">
                    Install PrimeMaxing as an app for the best notification experience.
                </div>
            )}
        </div>
    );
}

export default NotificationSettings;
